import React, { useMemo, useState } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import '../../LoginDialog.css';

function resolveRedirectTarget(locationState) {
  if (locationState && typeof locationState === 'object' && typeof locationState.from === 'string' && locationState.from.startsWith('/')) {
    return locationState.from;
  }
  return '/dashboard';
}

function LoginPage({ user, setUser }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const redirectTarget = useMemo(() => resolveRedirectTarget(location.state), [location.state]);

  if (user) {
    return <Navigate to={redirectTarget} replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!login.trim() || !password) {
      setError('Le login et le mot de passe sont obligatoires.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/users/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login: login.trim(), password }),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const payload = await response.json();
      if (!payload?.success) {
        setError(payload?.message || 'Login ou mot de passe invalide.');
        return;
      }

      setUser({
        login: payload.login,
        name: payload.login,
        role: payload.role || 'USER',
      });
      navigate(redirectTarget, { replace: true });
    } catch (submissionError) {
      setError(submissionError instanceof Error ? submissionError.message : 'Connexion impossible pour le moment.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-shell">
      <section className="login-page-card">
        <div className="login-page-copy">
          <span className="login-page-eyebrow">Authentification</span>
          <h1 className="login-page-title">Connectez-vous au cockpit EcotoneAI</h1>
          <p className="login-page-subtitle">
            Retrouvez vos réglages, vos connexions (exchanges et wallets) et les préférences liées à votre session.
          </p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-page-field">
            <span>Login</span>
            <input
              type="text"
              name="login"
              autoComplete="username"
              value={login}
              onChange={(event) => setLogin(event.target.value)}
              placeholder="Votre login"
            />
          </label>

          <label className="login-page-field">
            <span>Mot de passe</span>
            <input
              type="password"
              name="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Votre mot de passe"
            />
          </label>

          {error ? <div className="login-page-error">{error}</div> : null}

          <button type="submit" disabled={loading}>
            {loading ? 'Connexion en cours...' : 'Se connecter'}
          </button>
        </form>

        <div className="login-page-footer">
          <Link to="/">Retour à l’accueil</Link>
        </div>
      </section>
    </div>
  );
}

export default LoginPage;